import { EyeInvisibleOutlined, ArrowUpOutlined, CheckCircleOutlined, ClockCircleOutlined, DeleteOutlined, EditOutlined, ExclamationCircleOutlined, ArrowDownOutlined, DownloadOutlined, FileDoneOutlined, SearchOutlined, SwapRightOutlined } from '@ant-design/icons';
import { Tabs, Button, Checkbox, Col, DatePicker, DatePickerProps, Form, Input, Modal, Popconfirm, Row, Select, Space, Table, Tag } from 'antd';
import {
    BarController,
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    ChartOptions,
    Legend,
    LineController,
    LineElement,
    LinearScale,
    Plugin,
    PointElement,
    Tooltip
} from 'chart.js';
import dayjs, { Dayjs } from 'dayjs';
import { useEffect, useMemo, useState } from 'react';
import { Bar, Chart } from 'react-chartjs-2';
import { useDispatch, useSelector } from 'react-redux';
import { ContentHeader } from "../../components";
import { idQuyDauTu, layTenTienDoKPI, loaiLanhDaoPhuTrach, maChucVu, phongBan, trangThaiKPI } from '../../constants';
import { currencyFormat, dateCommon } from '../../helpers/common';
import { KPIPhongBanResponse, TheoDoiCongViec } from '../../models/kpi/KPIPhongBan';
import ContainerDonViPhuTrach from '../../modules/department/ContainerDonViPhuTrach';
import { anGiaoViecKPI, suaGiaoViecKPI, thongKeKPIPhongBan, timKiemGiaoViecKPI, xoaGiaoViecKPI, xuatExcelGiaoViecKPI } from '../../services/kpi';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import { tienDoColor } from './kpiHelper';
import { menuHelper } from '../../helpers/account';
import { Links } from '../../helpers/Links';
import { toast } from 'react-toastify';
import NhanVienPhongBanSelectBox from '../utils/NhanVienPhongBanSelectBox';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarController,
    BarElement,
    LineController,
    LineElement,
    PointElement,
    Tooltip,
    Legend
);

const fontTenPhongBan = '10px Arial';

// Cắt bớt tên phòng ban cho vừa khoảng trống dưới trục
const rutGonTen = (ctx: CanvasRenderingContext2D, text: string, maxWidth: number) => {
    if (ctx.measureText(text).width <= maxWidth) return text;
    let ten = text;
    while (ten.length > 1 && ctx.measureText(`${ten}…`).width > maxWidth) {
        ten = ten.slice(0, -1);
    }
    return `${ten}…`;
};
const SummaryCard = ({
    title,
    value,
    icon,
    color,
    trend,
}: {
    title: string;
    value: number | string;
    icon: React.ReactNode;
    color: string;
    trend?: { up: boolean; text: string };
}) => (
    <div
        style={{
            background: '#fff',
            border: '1px solid #f0f0f0',
            borderRadius: 12,
            padding: 16,
            display: 'flex',
            alignItems: 'center',
            gap: 14,
            boxShadow: '0 1px 2px rgba(0,0,0,0.03)',
            height: '100%',
        }}
    >
        <div
            style={{
                width: 48,
                height: 48,
                borderRadius: 12,
                background: `${color}1a`,
                color,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 22,
                flexShrink: 0,
            }}
        >
            {icon}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 12, color: '#6b7280', textTransform: 'uppercase', fontWeight: 600 }}>
                {title}
            </div>
            <div style={{ fontSize: 24, fontWeight: 700, color: '#111827', lineHeight: 1.2 }}>{value}</div>
            {trend && (
                <div style={{ fontSize: 12, color: trend.up ? '#16a34a' : '#dc2626', marginTop: 2 }}>
                    {trend.up ? <ArrowUpOutlined /> : <ArrowDownOutlined />} {trend.text}
                </div>
            )}
        </div>
    </div>
);
const ThongKeKPI = () => {
    const dispatch = useDispatch();
    const [filterThang, setFilterThang] = useState<string | undefined>(undefined);
    const [idDonVi, setIdDonVi] = useState<number>(idQuyDauTu);

    const user = useSelector((state: any) => state.auth.currentUser);
    const menu: any = menuHelper.checkMultiPermission([Links.KPI.TongHopKPI, Links.KPI.AnGiaoViec]);
    const showAnGiaoViec = menu[Links.KPI.AnGiaoViec];
    let ngayHienTai = (dayjs()).date() <= 10 ? (dayjs()).subtract(1, 'month') : dayjs();
    let thangHienTai = ngayHienTai.startOf('month').format('DD/MM/YYYY HH:mm:ss');
    const [activeTab, setActiveTab] = useState<string>("1");
    const [idNVGiaos, setIdNVGiaos] = useState<Array<number>>(user.isLanhDaoPhong || user.maChucVu == maChucVu.phoGiamDoc ? [user.idNhanVien] : []);
    const [thangNam, setThangNam] = useState<string>(thangHienTai);
    const [ngayThang, setNgayThang] = useState<Dayjs | null>(ngayHienTai);
    // khoảng ngày giao việc: mặc định lấy trọn năm đang xem
    const [ngayBatDau, setNgayBatDau] = useState<Dayjs>(dayjs().startOf('year'));
    const [ngayKetThuc, setNgayKetThuc] = useState<Dayjs>(dayjs().endOf('year'));
    const monthFormat = 'MM/YYYY';
    const dateFormat = ["DD/MM/YYYY", "DDMMYYYY"];
    const thangNamFormat: DatePickerProps['format'] = (value) => `Tháng ${value.format(monthFormat)}`;
    const [data, setData] = useState<Array<KPIPhongBanResponse>>([]);
    const [giaoViecs, setGiaoViecs] = useState<Array<TheoDoiCongViec>>([]);
    // công việc đang được lãnh đạo giao việc mở modal để sửa lại thông tin
    const [giaoViecDangSua, setGiaoViecDangSua] = useState<any>(null);
    const [dangLuuGiaoViec, setDangLuuGiaoViec] = useState<boolean>(false);
    // chuỗi công việc đang được hỏi xác nhận xóa
    const [idNhomXoaGiaoViec, setIdNhomXoaGiaoViec] = useState<number>(0);
    const [formSuaGiaoViec] = Form.useForm();

    useEffect(() => {
        if (!giaoViecDangSua) {
            formSuaGiaoViec.resetFields();
            return;
        }
        formSuaGiaoViec.setFieldsValue({
            tenCongViec: giaoViecDangSua.tenCongViec,
            thoiGianGiao: giaoViecDangSua.thoiGianGiao ? dayjs(giaoViecDangSua.thoiGianGiao) : null,
            thoiGianYeuCauHoanThanh: giaoViecDangSua.thoiGianYeuCauHoanThanh ? dayjs(giaoViecDangSua.thoiGianYeuCauHoanThanh) : null,
            choSuaThoiGianHT: !!giaoViecDangSua.choSuaThoiGianHT,
            baoCaoCapTren: !!giaoViecDangSua.baoCaoCapTren,
            ghiChu: giaoViecDangSua.ghiChu,
        });
    }, [giaoViecDangSua]);

    const onChange: DatePickerProps['onChange'] = (date) => {
        var dateStr = date?.startOf('month').format('DD/MM/YYYY HH:mm:ss');
        setNgayThang(date);
        if (dateStr) {
            setThangNam(dateStr);
            timkiem(idDonVi, dateStr);
        } else {
            setThangNam("");
            setData([]);
            setGiaoViecs([]);
        }
    };

    const onChangeDepartment = (e: any) => {
        if (e) {
            setIdDonVi(e.id);
            timkiem(e.id, thangNam);
            timKiemGiaoViec(e.id, ngayBatDau, ngayKetThuc, idNVGiaos);
        } else {
            setIdDonVi(0);
            setData([]);
            setGiaoViecs([]);
        }
    };

    const timkiem = async (idDonVi: number, thangNam: string) => {
        try {
            dispatch(showLoadingScreen());
            const temp = await thongKeKPIPhongBan(idDonVi, thangNam);

            setData((temp.data || []).map((item: any) => ({
                ...item,
                key: item.idKPICaNhan
            }))); 
            dispatch(hideLoadingScreen());
        } catch (error) {
            dispatch(hideLoadingScreen());
        }
    };

    // tìm kiếm và xuất excel dùng chung một bộ điều kiện lọc
    const layRequestGiaoViec = (idDonVi: number, batDau: Dayjs, ketThuc: Dayjs, idNVGiaos: Array<number>) => ({
        idDonVi: idDonVi,
        idNVGiaos: idNVGiaos,
        // gửi yyyy-MM-dd để model binder đọc đúng, không lệch ngày theo múi giờ
        ngayBatDau: batDau.format('YYYY-MM-DD'),
        ngayKetThuc: ketThuc.format('YYYY-MM-DD')
    });

    const timKiemGiaoViec = async (idDonVi: number, batDau: Dayjs, ketThuc: Dayjs, idNVGiaos: Array<number>) => {
        try {
            dispatch(showLoadingScreen());
            const temp = await timKiemGiaoViecKPI(layRequestGiaoViec(idDonVi, batDau, ketThuc, idNVGiaos));
            setGiaoViecs((temp || []).map((item: any) => ({
                ...item,
                key: item.id
            })));
            dispatch(hideLoadingScreen());
        } catch (error) {
            dispatch(hideLoadingScreen());
        }
    };

    // hai ô ngày tách rời (giống tìm kiếm nâng cao nhân viên) nên chỉ tìm kiếm lại
    // khi cả hai ô đều có giá trị và khoảng ngày hợp lệ
    const onChangeNgayBatDau = (date: Dayjs | null) => {
        if (!date) return;
        setNgayBatDau(date);
    };

    const onChangeNgayKetThuc = (date: Dayjs | null) => {
        if (!date) return;
        setNgayKetThuc(date);
    };

    useEffect(() => {
        timkiem(idDonVi, thangNam);
        timKiemGiaoViec(idDonVi, ngayBatDau, ngayKetThuc, idNVGiaos);
    }, []);

    const formatThangNam = (raw: string | Date) => {
        const date = new Date(raw as any);
        if (!isNaN(date.getTime())) {
            const mm = String(date.getMonth() + 1).padStart(2, '0');
            const yyyy = date.getFullYear();
            return `${mm}/${yyyy}`;
        }
        return '';
    };

    // 👉 GROUP DATA
    const groupByMonth: Record<string, KPIPhongBanResponse[]> = {};

    data.forEach((item) => {
        const month = formatThangNam(item.thangNam);
        if (!groupByMonth[month]) {
            groupByMonth[month] = [];
        }
        groupByMonth[month].push(item);
    });
    const labels = Object.keys(groupByMonth).sort((a, b) => {
        const [ma, ya] = a.split('/').map(Number);
        const [mb, yb] = b.split('/').map(Number);
        return new Date(ya, ma - 1).getTime() - new Date(yb, mb - 1).getTime();
    });

    const countByRank = (month: string, rank: string) => {
        return groupByMonth[month].filter(d => d.xepLoai === rank).length;
    };
    const dataAPlus = labels.map(m => countByRank(m, 'A+'));
    const dataA = labels.map(m => countByRank(m, 'A'));
    const dataB = labels.map(m => countByRank(m, 'B'));
    const dataC = labels.map(m => countByRank(m, 'C'));

    const chartXepLoai = {
        labels,
        datasets: [
            {
                label: 'A+',
                data: dataAPlus,
                backgroundColor: '#facc15',
                barThickness: 30,
                categoryPercentage: 0.6,
                barPercentage: 0.8,
            },
            {
                label: 'A',
                data: dataA,
                backgroundColor: '#22c55e',
                barThickness: 30,
                categoryPercentage: 0.6,
                barPercentage: 0.8,
            },
            {
                label: 'B',
                data: dataB,
                backgroundColor: '#f97316',
                barThickness: 30,
                categoryPercentage: 0.6,
                barPercentage: 0.8,
            },
            {
                label: 'C',
                data: dataC,
                backgroundColor: '#ef4444',
                barThickness: 30,
                categoryPercentage: 0.6,
                barPercentage: 0.8,
            },
        ],
    };

    const chartOptions: ChartOptions<'bar'> = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
                align: 'start',
                labels: {
                    boxWidth: 20,
                    padding: 15,
                    font: {
                        size: 13
                    }
                }
            },
        },
        scales: {
            x: { stacked: true },
            y: {
                stacked: true,
                beginAtZero: true,
                ticks: { stepSize: 4 },
            },
        },
    };

    const totalPlugin: Plugin<'bar'> = {
        id: 'totalPlugin',
        afterDatasetsDraw: (chart) => {
            const { ctx } = chart;

            chart.data.labels?.forEach((_, i) => {
                let sum = 0;
                chart.data.datasets.forEach((ds: any) => {
                    sum += ds.data[i];
                });

                const meta = chart.getDatasetMeta(chart.data.datasets.length - 1);
                const bar = meta.data[i];

                ctx.save();
                ctx.fillStyle = '#000';
                ctx.font = 'bold 12px Arial';
                ctx.textAlign = 'center';
                ctx.fillText(sum, bar.x, bar.y - 10);
                ctx.restore();
            });
        },
    };
    // ==========================================
    // BIỂU ĐỒ CÔNG VIỆC THEO THÁNG
    // Mỗi tháng gồm các cột của từng phòng ban (hoàn thành / đang thực hiện /
    // không hoàn thành), kèm đường tỷ lệ hoàn thành chung của cả tháng
    // ==========================================

    const tongSoCongViec = labels.map(month =>
        groupByMonth[month].reduce((s, d) => s + (d.soCongViec || 0), 0)
    );

    const hoanThanh = labels.map(month =>
        groupByMonth[month].reduce((s, d) =>
            s + (d.truoc || 0) + (d.dung || 0), 0)
    );

    // ✅ Tỷ lệ phải tính sau khi đã SUM
    const tyLeHoanThanh = labels.map((month, i) => {
        const tong = tongSoCongViec[i];
        const ht = hoanThanh[i];
        return tong > 0 ? Math.round((ht / tong) * 100) : 0;
    });

    // Danh sách phòng ban xuất hiện trong dữ liệu, sắp theo thứ tự đơn vị
    const donVis = useMemo(() => {
        const map = new Map<number, { idDonVi: number; ten: string; tenDayDu: string; thuTu: number }>();
        data.forEach((d) => {
            if (!map.has(d.idDonVi)) {
                map.set(d.idDonVi, {
                    idDonVi: d.idDonVi,
                    ten: d.ghiChuDonVi,
                    // tên đầy đủ hiển thị trên tooltip khi hover
                    tenDayDu: d.tenDonVi,
                    thuTu: d.thuTuDonVi ?? 0,
                });
            }
        });
        return Array.from(map.values()).sort((a, b) => a.thuTu - b.thuTu || a.idDonVi - b.idDonVi);
    }, [data]);

    // Chiều cao khoảng trống dưới trục X = độ dài tên phòng ban dài nhất (vẽ dọc),
    // giới hạn trong [60, 150]px để tên dài vẫn hiện đủ mà không chiếm hết biểu đồ
    const chieuCaoTenPhongBan = useMemo(() => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) return 90;
        ctx.font = fontTenPhongBan;
        const dai = Math.max(0, ...donVis.map((dv) => ctx.measureText(dv.ten).width));
        return Math.min(150, Math.max(60, Math.ceil(dai) + 18));
    }, [donVis]);

    // Số liệu công việc gom theo từng tháng của từng phòng ban
    const congViecTheoPhongBan = useMemo(() => {
        const map = new Map<string, { hoanThanh: number; dangThucHien: number; khongHoanThanh: number; tong: number }>();
        data.forEach((d) => {
            const key = `${formatThangNam(d.thangNam)}|${d.idDonVi}`;
            if (!map.has(key)) {
                map.set(key, { hoanThanh: 0, dangThucHien: 0, khongHoanThanh: 0, tong: 0 });
            }
            const item = map.get(key)!;
            item.hoanThanh += (d.truoc || 0) + (d.dung || 0);
            item.dangThucHien += d.dangThucHien || 0;
            item.khongHoanThanh += (d.tre || 0) + (d.loi || 0);
            item.tong += d.soCongViec || 0;
        });
        return map;
    }, [data]);

    const congViecRong = { hoanThanh: 0, dangThucHien: 0, khongHoanThanh: 0, tong: 0 };
    const layCongViec = (month: string, idDonVi: number) =>
        congViecTheoPhongBan.get(`${month}|${idDonVi}`) || congViecRong;

    // Mỗi phòng ban là một stack riêng -> các cột đứng cạnh nhau trong cùng một tháng
    const barDatasets = donVis.flatMap((dv) => {
        const chung = {
            type: 'bar' as const,
            stack: `dv-${dv.idDonVi}`,
            yAxisID: 'yCongViec',
            tenPhongBan: dv.ten,
            // số liệu đầy đủ của cột dùng cho tooltip khi hover
            tenDonVi: dv.tenDayDu,
            tongCongViec: labels.map((m) => layCongViec(m, dv.idDonVi).tong),
            hoanThanhArr: labels.map((m) => layCongViec(m, dv.idDonVi).hoanThanh),
            dangThucHienArr: labels.map((m) => layCongViec(m, dv.idDonVi).dangThucHien),
            khongHoanThanhArr: labels.map((m) => layCongViec(m, dv.idDonVi).khongHoanThanh),
            tyLeArr: labels.map((m) => {
                const cv = layCongViec(m, dv.idDonVi);
                return cv.tong > 0 ? Math.round((cv.hoanThanh / cv.tong) * 100) : 0;
            }),
        };
        return [
            { ...chung, label: 'Hoàn thành', backgroundColor: '#70AD47', data: labels.map((m) => layCongViec(m, dv.idDonVi).hoanThanh) },
            { ...chung, label: 'Đang thực hiện', backgroundColor: '#FFC000', data: labels.map((m) => layCongViec(m, dv.idDonVi).dangThucHien) },
            { ...chung, label: 'Không hoàn thành', backgroundColor: '#FF0000', data: labels.map((m) => layCongViec(m, dv.idDonVi).khongHoanThanh) },
        ];
    });

    const chartData: any = {
        labels,
        datasets: [
            ...barDatasets,
            {
                type: 'line',
                label: 'Tỷ lệ hoàn thành (%)',
                data: tyLeHoanThanh,
                borderColor: '#203864',
                backgroundColor: '#203864',
                borderWidth: 2,
                pointRadius: 5,
                tension: 0,
                yAxisID: 'yTyLe',
            },
        ],
    };

    // Trục công việc phải đủ cao cho cột cao nhất của một phòng ban
    const chieuCaoCot = labels.flatMap((m) =>
        donVis.map((dv) => {
            const cv = layCongViec(m, dv.idDonVi);
            return Math.max(cv.tong, cv.hoanThanh + cv.dangThucHien + cv.khongHoanThanh);
        })
    );
    const maxCongViec = Math.max(10, ...chieuCaoCot);
    const roundedMax = Math.ceil((maxCongViec * 1.4) / 10) * 10;

    const options: ChartOptions<'bar'> = {
        responsive: true,
        maintainAspectRatio: false,
        layout: { padding: { top: 55 } },
        datasets: {
            bar: { categoryPercentage: 0.85, barPercentage: 0.9, maxBarThickness: 26 },
        },
        interaction: { mode: 'nearest', intersect: true },
        plugins: {
            legend: {
                position: 'top',
                align: 'start',
                labels: {
                    // mọi phòng ban dùng chung bộ màu -> chỉ giữ lại một chú thích cho mỗi loại
                    filter: (item, chart) =>
                        chart.datasets.findIndex((ds) => ds.label === item.text) === item.datasetIndex,
                },
                onClick: (_e, item, legend) => {
                    // ẩn/hiện cùng lúc loại công việc đó ở tất cả phòng ban
                    const chart = legend.chart;
                    const dangHien = chart.isDatasetVisible(item.datasetIndex ?? 0);
                    chart.data.datasets.forEach((ds, i) => {
                        if (ds.label === item.text) chart.setDatasetVisibility(i, !dangHien);
                    });
                    chart.update();
                },
            },
            tooltip: {
                displayColors: false,
                callbacks: {
                    title: (items) => {
                        const item = items[0];
                        const ds: any = item.chart.data.datasets[item.datasetIndex];
                        // cột phòng ban -> tên đầy đủ; đường tỷ lệ -> chỉ hiện tháng
                        return ds.tenDonVi ? `${ds.tenDonVi} - Tháng ${item.label}` : `Tháng ${item.label}`;
                    },
                    // gộp toàn bộ số liệu của cột vào một tooltip
                    label: (item) => {
                        const ds: any = item.chart.data.datasets[item.datasetIndex];
                        const i = item.dataIndex;
                        if (ds.type === 'line') return `Tỉ lệ hoàn thành: ${item.formattedValue}%`;
                        if (!ds.tongCongViec) return '';
                        return [
                            `Tổng số công việc: ${ds.tongCongViec[i]}`,
                            `Hoàn thành: ${ds.hoanThanhArr[i]}`,
                            `Đang thực hiện: ${ds.dangThucHienArr[i]}`,
                            `Không hoàn thành: ${ds.khongHoanThanhArr[i]}`,
                            `Tỉ lệ hoàn thành: ${ds.tyLeArr[i]}%`,
                        ];
                    },
                },
            },
            title: {
                display: false,
                text: 'TÌNH HÌNH KẾT QUẢ CÔNG VIỆC THEO THÁNG',
                align: 'center',
                color: '#203864',
                position: 'bottom',
            },
        },
        scales: {
            x: {
                stacked: true,
                // padding đẩy nhãn tháng xuống dưới phần tên phòng ban và chừa sẵn chỗ vẽ,
                // nhưng chart.js cộng padding hai lần vào chiều cao trục nên trả lại phần dư
                afterFit: (scale) => { scale.height -= chieuCaoTenPhongBan; },
                ticks: { padding: chieuCaoTenPhongBan, font: { weight: 'bold' } },
            },
            yCongViec: { stacked: true, beginAtZero: true, max: roundedMax, title: { display: true, text: 'Công việc' } },
            yTyLe: {
                position: 'right',
                beginAtZero: true,
                max: 100,
                grid: { drawOnChartArea: false },
                ticks: { callback: (val) => `${val}%` },
            },
        },
    };

    const dataLabelPlugin: Plugin<'bar'> = {
        id: 'customDataLabels',
        afterDatasetsDraw(chart) {
            const { ctx, chartArea } = chart;
            chart.data.datasets.forEach((dataset, datasetIndex) => {
                const meta = chart.getDatasetMeta(datasetIndex);
                if (!meta.visible) return;
                meta.data.forEach((element: any, index) => {
                    const value = dataset.data[index] as number;
                    if (value === null || value === undefined) return;
                    const isLine = (dataset as any).type === 'line';
                    ctx.save();
                    ctx.textAlign = 'center';
                    if (isLine) {
                        ctx.font = 'bold 11px Arial';
                        ctx.fillStyle = '#203864';
                        let y = element.y - 25;
                        if (value >= 95) y = element.y + 18;
                        y = Math.max(chartArea.top + 12, y);
                        ctx.fillText(`${value}%`, element.x, y);
                    } else if (value > 0) {
                        // số liệu nằm giữa từng đoạn cột, bỏ qua khi đoạn quá thấp hoặc cột quá hẹp
                        ctx.font = 'bold 9px Arial';
                        const chieuCao = Math.abs(element.base - element.y);
                        const vuaCot = ctx.measureText(`${value}`).width <= element.width - 2;
                        if (chieuCao >= 12 && vuaCot) {
                            ctx.fillStyle = '#fff';
                            ctx.textBaseline = 'middle';
                            ctx.fillText(`${value}`, element.x, (element.y + element.base) / 2);
                        }
                    }
                    ctx.restore();
                });
            });
        },
    };

    // Tổng số công việc ở đầu cột và tên phòng ban vẽ dọc dưới mỗi cột
    const phongBanLabelPlugin: Plugin<'bar'> = {
        id: 'phongBanLabels',
        afterDatasetsDraw(chart) {
            const { ctx, chartArea } = chart;
            const stackDaVe = new Set<string>();

            chart.data.datasets.forEach((dataset: any) => {
                if (dataset.type === 'line' || !dataset.stack || stackDaVe.has(dataset.stack)) return;
                stackDaVe.add(dataset.stack);

                // các đoạn đang hiển thị của cùng một phòng ban
                const datasetTrongStack = chart.data.datasets
                    .map((ds: any, i) => ({ ds, i }))
                    .filter(({ ds, i }) => ds.stack === dataset.stack && chart.getDatasetMeta(i).visible);
                if (!datasetTrongStack.length) return;

                (chart.data.labels || []).forEach((_, index) => {
                    let x: number | null = null;
                    let beCot = 0;
                    let dinhCot = chartArea.bottom;
                    datasetTrongStack.forEach(({ i }) => {
                        const element: any = chart.getDatasetMeta(i).data[index];
                        if (!element) return;
                        x = element.x;
                        beCot = element.width;
                        dinhCot = Math.min(dinhCot, element.y);
                    });
                    if (x === null) return;

                    ctx.save();
                    // tổng số công việc của phòng ban trong tháng, bỏ qua khi cột hẹp
                    // hơn con số để không đè lên cột bên cạnh
                    const tong = dataset.tongCongViec?.[index] ?? 0;
                    ctx.font = 'bold 10px Arial';
                    if (tong > 0 && ctx.measureText(`${tong}`).width <= beCot + 4) {
                        ctx.textAlign = 'center';
                        ctx.textBaseline = 'alphabetic';
                        ctx.fillStyle = '#203864';
                        ctx.fillText(`${tong}`, x, Math.max(chartArea.top + 10, dinhCot - 6));
                    }
                    // tên phòng ban xoay dọc, đọc từ dưới lên
                    ctx.translate(x, chartArea.bottom + 6);
                    ctx.rotate(-Math.PI / 2);
                    ctx.font = fontTenPhongBan;
                    ctx.textAlign = 'right';
                    ctx.textBaseline = 'middle';
                    ctx.fillStyle = '#4b5563';
                    ctx.fillText(rutGonTen(ctx, dataset.tenPhongBan || '', chieuCaoTenPhongBan - 12), 0, 0);
                    ctx.restore();
                });
            });
        },
    };

    // ==========================================
    // BẢNG THEO DÕI VÒNG ĐỜI CÔNG VIỆC (bắt đầu -> hoàn thành)
    // ==========================================
    const theoDoiColumns = [
        {
            title: 'STT',
            key: 'stt',
            width: 60,
            align: 'center' as const,
            render: (_: any, row: any) => row.stt,
            onCell: (row: any) => ({ rowSpan: row.rowSpan }),
        },
        {
            title: 'Tên nhân viên',
            dataIndex: 'hoTen',
            width: 220,
            key: 'hoTen',
            onCell: (row: any) => ({ rowSpan: row.rowSpan }),
        },
        {
            title: 'Tên công việc',
            dataIndex: 'tenCongViec',
            key: 'tenCongViec',
            onCell: (row: any) => ({ rowSpan: row.rowSpan }),
        },
        {
            title: 'Tháng',
            dataIndex: 'thang',
            key: 'thang',
            width: 90,
            align: 'center' as const,
            render: (v: string) => <b>{v}</b>,
        },
        {
            title: 'Tiến độ',
            dataIndex: 'tienDo',
            key: 'tienDo',
            width: 100,
            align: 'center' as const,
            render: (v: number) => (
                <Tag color={tienDoColor(v)} style={{ color: '#fff', fontWeight: 600, margin: 0 }}>
                    {layTenTienDoKPI(v)}
                </Tag>
            ),
        },
        {
            title: 'Ghi chú',
            dataIndex: 'ghiChu',
            width: 300,
            key: 'ghiChu',
            render: (v: string) => <b>{v}</b>,
        },
    ];

    const theoDoiRows = useMemo(() => {
        const all: Array<{ id: number; idNhom: number; idNhanVien: number; hoTen: string; tenCongViec: string; ghiChu: string; thang: string; thangNam: string; tienDo: number; seq: number }> = [];
        // giữ nguyên thứ tự trả về từ API (đã ORDER BY ThangNam, DV.ThuTu, CV.ThuTu, NV.ThuTu)
        data.forEach((d) => {
            (d.theoDoiCongViecs || []).forEach((cv: any) => {
                all.push({
                    id: cv.id, // Id ChiTietKPI (dùng để ẩn khỏi thống kê)
                    idNhom: cv.idNhom,
                    idNhanVien: cv.idNhanVien ?? d.idNhanVien,
                    hoTen: cv.hoTen,
                    tenCongViec: cv.tenCongViec,
                    ghiChu: cv.ghiChu,
                    thang: formatThangNam(cv.thangNam),
                    thangNam: cv.thangNam,
                    tienDo: cv.tienDo,
                    seq: all.length, // thứ tự xuất hiện theo API
                });
            });
        });
        // thứ tự mỗi nhóm công việc lấy theo lần xuất hiện đầu tiên trong thứ tự API
        // (bản ghi gốc = tháng sớm nhất, đã theo ThangNam, DV.ThuTu, CV.ThuTu, NV.ThuTu)
        const firstSeqByNhom = new Map<number, number>();
        all.forEach((r) => {
            if (!firstSeqByNhom.has(r.idNhom)) firstSeqByNhom.set(r.idNhom, r.seq);
        });
        // gom các dòng cùng công việc nằm liền nhau (để gộp ô), nhóm sắp theo thứ tự API,
        // trong mỗi nhóm giữ thứ tự thời gian (vòng đời công việc từ lúc bắt đầu đến khi hoàn thành)
        all.sort((a, b) => {
            const ga = firstSeqByNhom.get(a.idNhom) ?? Number.MAX_SAFE_INTEGER;
            const gb = firstSeqByNhom.get(b.idNhom) ?? Number.MAX_SAFE_INTEGER;
            if (ga !== gb) return ga - gb;
            return a.seq - b.seq;
        });
        // tính rowSpan để gộp ô tên công việc theo nhóm
        const countByNhom: Record<number, number> = {};
        all.forEach((r) => { countByNhom[r.idNhom] = (countByNhom[r.idNhom] || 0) + 1; });
        const seen: Record<number, boolean> = {};
        let sttNhom = 0;
        return all.map((r) => {
            const isFirst = !seen[r.idNhom];
            seen[r.idNhom] = true;
            if (isFirst) sttNhom += 1;
            return { ...r, key: r.id, stt: isFirst ? sttNhom : 0, rowSpan: isFirst ? countByNhom[r.idNhom] : 0 };
        });
    }, [data]);

    // ==========================================
    // BẢNG THEO DÕI GIAO VIỆC (bắt đầu -> hoàn thành)
    // ==========================================
    // không có công việc nào do chính người đang xem giao thì không dòng nào có nút Sửa/Xóa -> ẩn luôn cột thao tác
    const coThaoTacGiaoViec = useMemo(() => (giaoViecs || []).some((cv: any) => cv.idNVGiao == user.idNhanVien), [giaoViecs, user.idNhanVien]) || showAnGiaoViec;

    const theoDoiGiaoViecColumns = [
        {
            title: 'STT',
            key: 'stt',
            width: 45,
            align: 'center' as const,
            render: (_: any, row: any) => row.stt,
            onCell: (row: any) => ({ rowSpan: row.rowSpan }),
        },
        {
            title: 'Lãnh đạo giao',
            dataIndex: 'tenNVGiao',
            width: 130,
            key: 'tenNVGiao',
            onCell: (row: any) => ({ rowSpan: row.rowSpan }),
        },
        {
            title: 'Người thực hiện',
            dataIndex: 'hoTen',
            width: 130,
            key: 'hoTen',
            onCell: (row: any) => ({ rowSpan: row.rowSpan }),
        },
        {
            title: 'Tên công việc',
            dataIndex: 'tenCongViec',
            key: 'tenCongViec',
            width: 280,
            onCell: (row: any) => ({ rowSpan: row.rowSpan }),
            // công việc không báo cáo cấp trên thì tô màu để dễ phân biệt
            render: (v: string, row: any) => (
                <span style={row.baoCaoCapTren ? undefined : { color: '#cf1322' }}>{v}</span>
            ),
        },
        {
            title: 'Thời gian',
            dataIndex: 'thoiGian',
            key: 'thoiGian',
            // đủ rộng để khoảng ngày không bị xuống dòng
            width: 160,
            align: 'center' as const,
            render: (v: string) => <span style={{ whiteSpace: 'nowrap' }}>{v}</span>,
        },
        {
            title: 'Tiến độ',
            dataIndex: 'tienDo',
            key: 'tienDo',
            width: 80,
            align: 'center' as const,
            render: (v: number) => (
                <Tag color={tienDoColor(v)} style={{ color: '#fff', fontWeight: 600, margin: 0 }}>
                    {layTenTienDoKPI(v)}
                </Tag>
            ),
        },
        {
            title: 'Ghi chú',
            dataIndex: 'ghiChu',
            width: 200,
            key: 'ghiChu',
            render: (v: string) => <span>{v}</span>,
        },
        {
            title: '',
            key: 'thaoTacGiaoViec',
            width: 70,
            align: 'center' as const,
            render: (_: any, row: any) => (
                <Space size={4}>
                    {(showAnGiaoViec || row.idNVGiao == user.idNhanVien) &&
                        <Popconfirm
                            title="Kết thúc theo dõi công việc"
                            description="Toàn bộ bản ghi của công việc này (tất cả các tháng) sẽ không hiển thị tại bảng theo dõi công việc được giao. Bạn có chắc chắn?"
                            okText="Đồng ý"
                            cancelText="Hủy"
                            onConfirm={() => handleAnGiaoViec(row)}
                            overlayClassName="hrm-popconfirm"
                            // tô sáng cả chuỗi công việc sắp bị ẩn trong lúc hỏi xác nhận
                            onOpenChange={(mo) => setIdNhomXoaGiaoViec(mo ? row.idNhom : 0)}
                        >
                            <Button danger size="small" className="hrm-btn-warning" title="Kết thúc theo dõi" icon={<EyeInvisibleOutlined />}
                            >
                            </Button>
                        </Popconfirm>
                    }
                    {/* chỉ sửa được khi công việc mới xuất hiện ở 1 tháng (chưa kéo dài qua tháng sau)
                        và KPI của nhân viên chưa trình lãnh đạo phòng */}
                    {row.soThang == 1 && row.trangThai < trangThaiKPI.trinhLanhDaoPhong && row.idNVGiao == user.idNhanVien &&
                        < Button
                            className="hrm-btn hrm-btn-success"
                            size="small" title="Chỉnh sửa"
                            icon={<EditOutlined />}
                            onClick={() => moModalSuaGiaoViec(row)}
                        >
                        </Button>}
                    {
                        row.idNVGiao == user.idNhanVien && <Popconfirm
                            title="Xóa công việc đã giao"
                            description="Toàn bộ bản ghi của công việc này (tất cả các tháng) sẽ bị xóa khỏi KPI của nhân viên. Bạn có chắc chắn?"
                            okText="Xóa"
                            cancelText="Hủy"
                            onConfirm={() => handleXoaGiaoViec(row)}
                            overlayClassName="hrm-popconfirm"
                            // tô sáng cả chuỗi công việc sắp bị xóa trong lúc hỏi xác nhận
                            onOpenChange={(mo) => setIdNhomXoaGiaoViec(mo ? row.idNhom : 0)}
                        >
                            <Button danger size="small" className="hrm-btn-delete" title="Xóa công việc" icon={<DeleteOutlined />}
                            >
                            </Button>
                        </Popconfirm>}
                </Space>
            ),
        },
    ]
        .filter((c) => c.key !== 'thaoTacGiaoViec' || coThaoTacGiaoViec);

    // bề rộng tối thiểu của bảng = tổng width các cột đang hiển thị: màn hình rộng hơn thì các cột
    // tự giãn kín bảng (không có thanh cuộn ngang), màn hình hẹp hơn mới phải cuộn ngang
    const widthBangGiaoViec = theoDoiGiaoViecColumns.reduce((tong: number, c: any) => tong + (c.width || 0), 0);
    const theoDoiGiaoViecRows = useMemo(() => {
        const all: Array<{
            id: number; idNhom: number; idNhanVien: number; hoTen: string; tenCongViec: string; ghiChu: string; thang: string; thoiGian: string; trangThai: number, baoCaoCapTren: boolean,
            thangNam: string; tienDo: number; seq: number, tenNVGiao: string, idNVGiao: number, thoiGianGiao: string, thoiGianYeuCauHoanThanh: string, choSuaThoiGianHT: boolean
        }> = [];

        (giaoViecs || []).forEach((cv: any) => {
            all.push({
                id: cv.id, // Id ChiTietKPI (dùng để ẩn khỏi thống kê)
                idNhom: cv.idNhom,
                idNhanVien: cv.idNhanVien,
                hoTen: cv.hoTen,
                tenCongViec: cv.tenCongViec,
                ghiChu: cv.ghiChu,
                thang: formatThangNam(cv.thangNam),
                thoiGian: `${dateCommon.formatDate(cv.thoiGianGiao, "dd/MM/yyyy")}-${dateCommon.formatDate(cv.thoiGianYeuCauHoanThanh, "dd/MM/yyyy") }`,
                thangNam: cv.thangNam,
                tienDo: cv.tienDo,
                seq: all.length,
                tenNVGiao: cv.tenNVGiao,
                idNVGiao: cv.idNVGiao,
                // giá trị gốc để đổ vào form sửa công việc
                thoiGianGiao: cv.thoiGianGiao,
                thoiGianYeuCauHoanThanh: cv.thoiGianYeuCauHoanThanh,
                choSuaThoiGianHT: cv.choSuaThoiGianHT,
                baoCaoCapTren: cv.baoCaoCapTren,
                trangThai: cv.trangThai
            });
        });
        const firstSeqByNhom = new Map<number, number>();
        all.forEach((r) => {
            if (!firstSeqByNhom.has(r.idNhom)) firstSeqByNhom.set(r.idNhom, r.seq);
        });
        all.sort((a, b) => {
            const ga = firstSeqByNhom.get(a.idNhom) ?? Number.MAX_SAFE_INTEGER;
            const gb = firstSeqByNhom.get(b.idNhom) ?? Number.MAX_SAFE_INTEGER;
            if (ga !== gb) return ga - gb;
            return a.seq - b.seq;
        });
        // tính rowSpan để gộp ô tên công việc theo nhóm
        const countByNhom: Record<number, number> = {};
        all.forEach((r) => { countByNhom[r.idNhom] = (countByNhom[r.idNhom] || 0) + 1; });
        const seen: Record<number, boolean> = {};
        let sttNhom = 0;
        return all.map((r) => {
            const isFirst = !seen[r.idNhom];
            seen[r.idNhom] = true;
            if (isFirst) sttNhom += 1;
            // soThang: số bản ghi của chuỗi công việc (công việc kéo dài qua bao nhiêu tháng)
            return { ...r, key: r.id, stt: isFirst ? sttNhom : 0, rowSpan: isFirst ? countByNhom[r.idNhom] : 0, soThang: countByNhom[r.idNhom] };
        });
    }, [giaoViecs]);

    // ẩn cả chuỗi bản ghi của công việc (các tháng kế thừa nhau) khỏi bảng thống kê giao việc
    const handleAnGiaoViec = async (row: any) => {
        const idChiTiets = theoDoiGiaoViecRows.filter((r) => r.idNhom == row.idNhom).map((r) => r.id);
        if (idChiTiets.length === 0) return;
        try {
            dispatch(showLoadingScreen());
            await anGiaoViecKPI(idChiTiets);
            dispatch(hideLoadingScreen());
            toast.success("Đã ẩn công việc khỏi thống kê");
            await timKiemGiaoViec(idDonVi, ngayBatDau, ngayKetThuc, idNVGiaos);
        } catch (ex) {
            dispatch(hideLoadingScreen());
            toast.error("Ẩn công việc khỏi thống kê không thành công. Vui lòng thử lại");
        }
    }

    const moModalSuaGiaoViec = (row: any) => {
        setGiaoViecDangSua(row);
    }

    // lãnh đạo đã giao việc sửa lại thông tin của chính bản ghi công việc đang xem
    const handleSuaGiaoViec = async (values: any) => {
        if (!giaoViecDangSua) return;
        setDangLuuGiaoViec(true);
        dispatch(showLoadingScreen());
        try {
            await suaGiaoViecKPI({
                idChiTiets: [giaoViecDangSua.id],
                tenCongViec: values.tenCongViec,
                thoiGianGiao: values.thoiGianGiao ? values.thoiGianGiao.toDate() : null,
                thoiGianYeuCauHoanThanh: values.thoiGianYeuCauHoanThanh ? values.thoiGianYeuCauHoanThanh.toDate() : null,
                choSuaThoiGianHT: !!values.choSuaThoiGianHT,
                baoCaoCapTren: !!values.baoCaoCapTren,
                ghiChu: values.ghiChu,
            });
            setGiaoViecDangSua(null);
            toast.success("Sửa công việc thành công");
            await timKiemGiaoViec(idDonVi, ngayBatDau, ngayKetThuc, idNVGiaos);
        } catch (ex: any) {
            toast.error(ex?.message || "Sửa công việc không thành công. Vui lòng thử lại");
        }
        setDangLuuGiaoViec(false);
        dispatch(hideLoadingScreen());
    }

    // xóa cả chuỗi bản ghi của công việc (tất cả các tháng kế thừa nhau) khỏi KPI nhân viên
    const handleXoaGiaoViec = async (row: any) => {
        const idChiTiets = theoDoiGiaoViecRows.filter((r) => r.idNhom == row.idNhom).map((r) => r.id);
        if (idChiTiets.length === 0) return;
        dispatch(showLoadingScreen());
        try {
            await xoaGiaoViecKPI(idChiTiets);
            toast.success("Xóa công việc thành công");
            await timKiemGiaoViec(idDonVi, ngayBatDau, ngayKetThuc, idNVGiaos);
        } catch (ex: any) {
            toast.error(ex?.message || "Xóa công việc không thành công. Vui lòng thử lại");
        }
        dispatch(hideLoadingScreen());
    }

    const handleExportGiaoViec = async () => {
        dispatch(showLoadingScreen());
        try {
            var response = await xuatExcelGiaoViecKPI(layRequestGiaoViec(idDonVi, ngayBatDau, ngayKetThuc, idNVGiaos));
            let link = document.createElement('a');
            link.download = `DSXuLyGiaoViec.xlsx`;
            let blob = new Blob([response.data], { type: response.data.type });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
        } catch (ex) {
            toast.error("Xuất báo cáo không thành công. Vui lòng thử lại");
        }

        dispatch(hideLoadingScreen());
    }
    // ==========================================
    // Danh sách kết quả xếp loại KPI theo Nhân viên 
    // ==========================================
    // màu cho từng xếp loại
    const rankColors: Record<string, string> = { 'A+': '#eab308', 'A': '#22c55e', 'B': '#3b82f6', 'C': '#ef4444' };
    // hiển thị danh sách tháng đạt xếp loại: "Tháng 1; 2; 5"
    const renderThangRank = (thangs: number[], color: string) =>
        thangs && thangs.length ? (
            <span style={{ color, fontWeight: 600 }}>Tháng {thangs.join('; ')}</span>
        ) : null;
    // badge số lượng công việc dạng tròn
    const renderCountBadge = (value: number, color: string) => (
        <span
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: 26,
                height: 26,
                padding: '0 8px',
                borderRadius: 13,
                background: `${color}1a`,
                color,
                fontWeight: 700,
            }}
        >
            {value}
        </span>
    );

    const nhanVienColumns = [
        {
            title: 'STT',
            dataIndex: 'stt',
            key: 'stt',
            width: 60,
            align: 'center' as const,
        },
        {
            title: 'Họ tên',
            dataIndex: 'hoTen',
            key: 'hoTen',
            width: 200,
        },
        {
            title: 'Phòng/Ban',
            dataIndex: 'tenDonVi',
            key: 'tenDonVi',
            width: 180,
        },
        {
            title: 'Kết quả xếp loại',
            align: 'center' as const,
            children: [
                {
                    title: 'A+',
                    key: 'aPlus',
                    width: 150,
                    align: 'center' as const,
                    render: (_: any, r: any) => renderThangRank(r.xepLoaiThang['A+'], rankColors['A+']),
                },
                {
                    title: 'A',
                    key: 'a',
                    width: 150,
                    align: 'center' as const,
                    render: (_: any, r: any) => renderThangRank(r.xepLoaiThang['A'], rankColors['A']),
                },
                {
                    title: 'B',
                    key: 'b',
                    width: 150,
                    align: 'center' as const,
                    render: (_: any, r: any) => renderThangRank(r.xepLoaiThang['B'], rankColors['B']),
                },
                {
                    title: 'C',
                    key: 'c',
                    width: 150,
                    align: 'center' as const,
                    render: (_: any, r: any) => renderThangRank(r.xepLoaiThang['C'], rankColors['C']),
                },
            ],
        },
        {
            title: 'Tổng số công việc',
            dataIndex: 'soCongViec',
            key: 'soCongViec',
            width: 130,
            align: 'center' as const,
        },
        {
            title: 'Đã hoàn thành',
            dataIndex: 'daHoanThanh',
            key: 'daHoanThanh',
            width: 120,
            align: 'center' as const,
            render: (v: number) => renderCountBadge(v, '#22c55e'),
        },
        {
            title: 'Chưa hoàn thành',
            align: 'center' as const,
            children: [
                {
                    title: 'Đang TH',
                    dataIndex: 'dangThucHien',
                    key: 'dangThucHien',
                    width: 100,
                    align: 'center' as const,
                    render: (v: number) => renderCountBadge(v, '#f59e0b'),
                },
                {
                    title: 'Trễ',
                    dataIndex: 'tre',
                    key: 'tre',
                    width: 90,
                    align: 'center' as const,
                    render: (v: number) => renderCountBadge(v, '#ef4444'),
                },
            ],
        },
        {
            title: 'Lỗi vi phạm',
            dataIndex: 'soLoi',
            key: 'soLoi',
            width: 90,
            align: 'center' as const,
            render: (v: number) => renderCountBadge(v, '#ef4444'),
        },
    ];

    // Tổng hợp theo từng nhân viên: mỗi nhân viên 1 dòng
    // sắp xếp theo Thứ tự đơn vị -> Thứ tự chức vụ -> Thứ tự nhân viên
    const nhanVienRows = useMemo(() => {
        const map = new Map<number, any>();
        const order: number[] = [];
        data.forEach((d) => {
            if (!map.has(d.idNhanVien)) {
                map.set(d.idNhanVien, {
                    idNhanVien: d.idNhanVien,
                    hoTen: d.hoTen,
                    tenDonVi: d.tenDonVi,
                    thuTuDonVi: d.thuTuDonVi ?? 0,
                    thuTuChucVu: d.thuTuChucVu ?? 0,
                    thuTuNhanVien: d.thuTuNhanVien ?? 0,
                    xepLoaiThang: { 'A+': [] as number[], 'A': [] as number[], 'B': [] as number[], 'C': [] as number[] },
                    soCongViec: 0,
                    daHoanThanh: 0,
                    dangThucHien: 0,
                    tre: 0,
                    soLoi: 0,
                    thangNamMoiNhat: -Infinity,
                });
                order.push(d.idNhanVien);
            }
            const item = map.get(d.idNhanVien);
            const moc = new Date(d.thangNam as any).getTime();
            const thangNum = new Date(d.thangNam as any).getMonth() + 1;
            // nhân viên có thể chuyển đơn vị giữa các tháng -> lấy phòng/ban của tháng sau cùng
            if (!isNaN(moc) && moc >= item.thangNamMoiNhat) {
                item.thangNamMoiNhat = moc;
                item.tenDonVi = d.tenDonVi;
                item.thuTuDonVi = d.thuTuDonVi ?? 0;
            }
            if (d.xepLoai && item.xepLoaiThang[d.xepLoai]) {
                item.xepLoaiThang[d.xepLoai].push(thangNum);
            }
            // số liệu công việc cộng tổng tất cả các tháng
            item.soCongViec += d.soCongViec || 0;
            item.daHoanThanh += (d.truoc || 0) + (d.dung || 0);
            item.dangThucHien += d.dangThucHien || 0;
            item.tre += d.tre || 0;
            item.soLoi += (d.loiViPhams || []).length;
        });
        const items = order.map((id) => map.get(id));
        // sắp xếp theo Thứ tự đơn vị -> Thứ tự chức vụ -> Thứ tự nhân viên
        items.sort((a, b) => {
            if (a.thuTuDonVi !== b.thuTuDonVi) return a.thuTuDonVi - b.thuTuDonVi;
            if (a.thuTuChucVu !== b.thuTuChucVu) return a.thuTuChucVu - b.thuTuChucVu;
            return a.thuTuNhanVien - b.thuTuNhanVien;
        });
        return items.map((item, index) => {
            (['A+', 'A', 'B', 'C'] as const).forEach((r) => item.xepLoaiThang[r].sort((a: number, b: number) => a - b));
            return { ...item, key: item.idNhanVien, stt: index + 1 };
        });
    }, [data]);
    // ==========================================
    // BẢNG LỖI VI PHẠM
    // ==========================================
    const monthOptions = useMemo(() => {
        // mỗi tháng chỉ xuất hiện 1 lần, sắp xếp theo thời gian
        const values = Array.from(new Set(data.map((d) => formatThangNam(d.thangNam)))).filter(Boolean);
        values.sort((a, b) => {
            const [ma, ya] = a.split('/').map(Number);
            const [mb, yb] = b.split('/').map(Number);
            return new Date(ya, ma - 1).getTime() - new Date(yb, mb - 1).getTime();
        });
        return values.map((v) => ({ label: `Tháng ${v}`, value: v }));
    }, [data]);


    const violations = useMemo(() => {
        const map = new Map<string, any>();

        // lọc theo tháng đang chọn (nếu có)
        const nguon = filterThang ? data.filter((d) => formatThangNam(d.thangNam) === filterThang) : data;
        nguon.forEach((d) => {
            const hoTen = d.hoTen;

            (d.loiViPhams || []).forEach((v) => {
                if (!map.has(hoTen)) {
                    map.set(hoTen, {
                        key: hoTen,
                        hoTen,
                        tongLoi: 0,
                        tongDiemTru: 0,
                        noiDungs: [],
                        details: [],
                    });
                }

                const item = map.get(hoTen);

                item.tongLoi += 1;
                item.tongDiemTru += Math.abs(v.diemTru || 0);
                if (v.noiDung) item.noiDungs.push(v.noiDung);
                item.details.push(v);
            });
        });

        let result = Array.from(map.values());

        // ✅ sort nhiều lỗi -> ít lỗi
        result.sort((a, b) => b.tongLoi - a.tongLoi);

        // ✅ thêm STT
        result = result.map((item, index) => ({
            ...item,
            stt: index + 1,
        }));

        return result;
    }, [data, filterThang]);
    const tongSoLoi = violations.reduce((s, v) => s + (v.tongLoi || 0), 0);
    const tongDiemTru = violations.reduce((s, v) => s + (v.tongDiemTru || 0), 0);

    const violationColumns = [
        {
            title: 'STT',
            dataIndex: 'stt',
            key: 'stt',
            width: 60,
            align: 'center' as const,
        },
        {
            title: 'Họ tên',
            dataIndex: 'hoTen',
            key: 'hoTen',
            width: 220,
        },
        {
            title: 'Nội dung vi phạm',
            dataIndex: 'noiDungs',
            key: 'noiDungs',
            render: (noiDungs: string[]) => (
                <ul style={{ margin: 0, paddingLeft: 18 }}>
                    {(noiDungs || []).map((nd, i) => (
                        <li key={i}>{nd}</li>
                    ))}
                </ul>
            ),
        },
        {
            title: 'Tổng lỗi',
            dataIndex: 'tongLoi',
            key: 'tongLoi',
            align: 'center' as const,
            width: 100,
        },
        {
            title: 'Tổng điểm trừ',
            dataIndex: 'tongDiemTru',
            key: 'tongDiemTru',
            align: 'center' as const,
            width: 120,
            render: (v: number) => (
                <Tag color="#ef4444" style={{ color: '#fff', fontWeight: 700 }}>
                    -{v}
                </Tag>
            ),
        },
    ];
    ///Tổng quan
    const tongQuan = useMemo(() => {
        const tongCV = data.reduce((s, d) => s + (d.soCongViec || 0), 0);
        const tongHT = data.reduce((s, d) => s + (d.truoc || 0) + (d.dung || 0), 0);
        const tongDTH = data.reduce((s, d) => s + (d.dangThucHien || 0), 0);
        const tongTre = data.reduce((s, d) => s + (d.tre || 0), 0);
        const tyLe = tongCV > 0 ? Math.round((tongHT / tongCV) * 100) : 0;
        return { tongCV, tongHT, tongDTH, tongTre, tyLe };
    }, [data]);
    return (
        <section>
            <ContentHeader title="Thống kê KPI" />
            <div className="card card-primary" style={{ padding: '10px 12px', marginBottom: 4 }}>
                {activeTab == "3" ?
                    <Row gutter={16} align="middle" wrap={false}>
                        <Col span="8" flex="none">
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <span style={{ fontWeight: 600, whiteSpace: 'nowrap' }}>Từ ngày - Đến ngày:</span>
                                <div style={{ border: '1px solid #d9d9d9', borderRadius: '6px', display: 'flex', alignItems: 'center', gap: '8px', height: '36px' }}>
                                    <DatePicker
                                        allowClear={false}
                                        suffixIcon={null}
                                        changeOnBlur={true}
                                        value={ngayBatDau}
                                        style={{ width: "100%", border: 'none', boxShadow: 'none' }}
                                        placeholder="--Bắt đầu--"
                                        format={dateFormat}
                                        onChange={onChangeNgayBatDau}
                                    />
                                    <SwapRightOutlined style={{ fontSize: '18px', color: '#d9d9d9' }} />
                                    <DatePicker
                                        allowClear={false}
                                        changeOnBlur={true}
                                        value={ngayKetThuc}
                                        style={{ width: "100%", border: 'none', boxShadow: 'none' }}
                                        placeholder="--Kết thúc--"
                                        format={dateFormat}
                                        onChange={onChangeNgayKetThuc}
                                    />
                                </div>
                            </div>
                        </Col>
                        <Col span="6" flex="1 1 0">
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <span style={{ fontWeight: 600, whiteSpace: 'nowrap' }}>Lãnh đạo giao:</span>
                                <div style={{ flex: 1, minWidth: 0, maxWidth: 300 }}>
                                    <NhanVienPhongBanSelectBox giaoViec dsNguoiGiaoViec allowClear value={idNVGiaos} onChange={(e: any) => {
                                        setIdNVGiaos(e.target.value || []);
                                    }} />
                                </div>
                            </div>
                        </Col>
                        <Col span="10" flex="1 1 0">
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <span style={{ fontWeight: 600, whiteSpace: 'nowrap' }}>Đơn vị thực hiện:</span>
                                <div style={{ flex: 1, minWidth: 0, maxWidth:500 }}>
                                    <ContainerDonViPhuTrach
                                        showHeader={false}
                                        isKPI
                                        donViQuanLy={menu[Links.KPI.AnGiaoViec] || menu[Links.KPI.TongHopKPI]}
                                        onChange={onChangeDepartment}
                                        value={idDonVi}
                                        loaiPhuTrach={loaiLanhDaoPhuTrach.tatCa}
                                    />
                                </div>
                                <Button
                                    type="primary"
                                    icon={<SearchOutlined />}
                                    onClick={() => timKiemGiaoViec(idDonVi, ngayBatDau, ngayKetThuc, idNVGiaos)}
                                >
                                    Tìm kiếm
                                </Button>
                            </div>
                        </Col>
                    </Row> :
                    <Row gutter={16}>
                        <Col span={4}>
                            <DatePicker
                                allowClear={false}
                                value={ngayThang}
                                style={{ width: "100%" }}
                                picker="month"
                                onChange={onChange}
                                format={thangNamFormat}
                            />
                        </Col>
                        <Col span={7}>
                            <ContainerDonViPhuTrach
                                showHeader={false}
                                isKPI
                                donViQuanLy={menu[Links.KPI.AnGiaoViec] || menu[Links.KPI.TongHopKPI] || menu[Links.KPI.VanPhongGiaoViec]}
                                onChange={onChangeDepartment}
                                value={idDonVi}
                                loaiPhuTrach={loaiLanhDaoPhuTrach.phuTrach1}
                            />
                        </Col>
                        <Col span={3}>
                            <Space>
                                <Button
                                    type="primary"
                                    icon={<SearchOutlined rev="" />}
                                    onClick={() => timkiem(idDonVi, thangNam)}
                                >
                                    Tìm kiếm
                                </Button>
                            </Space>
                        </Col>
                    </Row>
                }
            </div>
            <Row>
                <Col span="24">
                    <Tabs activeKey={activeTab} onChange={(key) => setActiveTab(key)}
                        items={[
                            {
                                key: '1',
                                label: 'Công việc',
                                children: <div className="card card-body" style={{ marginTop: 10, backgroundColor: '#fff', borderRadius: 8 }}>
                                    <Row gutter={8}>
                                        {/* BẢNG THEO DÕI VÒNG ĐỜI CÔNG VIỆC */}
                                        <Col span={24}>
                                            <Row align="middle" justify="space-between" style={{ marginBottom: "9px" }}>
                                                <Col span={24}>
                                                    <h4
                                                        style={{
                                                            fontSize: 14,
                                                            fontWeight: 700,
                                                            color: '#203864',
                                                            textTransform: 'uppercase',
                                                            marginBottom: 0,
                                                            marginRight: "10px",
                                                            display: 'inline-block',
                                                        }}
                                                    >
                                                        THEO DÕI CÔNG VIỆC CHƯA HOÀN THÀNH
                                                    </h4>
                                                    <Space >
                                                        <Tag
                                                            color="#ef4444"
                                                            style={{
                                                                color: '#fff',
                                                                margin: 0,
                                                                padding: '2px 8px',
                                                                lineHeight: '1.5',
                                                                fontSize: '12px',
                                                                fontWeight: 600
                                                            }}
                                                        >
                                                            {new Set(theoDoiRows.map((r) => r.idNhom)).size} CÔNG VIỆC
                                                        </Tag>
                                                    </Space>
                                                </Col>
                                            </Row>
                                            <Table
                                                size="small"
                                                columns={theoDoiColumns}
                                                dataSource={theoDoiRows}
                                                pagination={false}
                                                scroll={{ y: 400 }}
                                                bordered
                                                locale={{ emptyText: 'Không có công việc cần theo dõi' }}
                                            />
                                        </Col>
                                        <Col span={24} style={{ marginTop: 30, marginBottom: "20px" }}>
                                            <h4 style={{ fontSize: 14, fontWeight: 700, color: '#203864', textTransform: 'uppercase', marginBottom: -5 }}>
                                                TÌNH HÌNH KẾT QUẢ CÔNG VIỆC
                                            </h4>
                                        </Col>
                                        <Col span={6}>
                                            <SummaryCard
                                                title="Tổng công việc"
                                                value={currencyFormat.formatMoney(tongQuan.tongCV)}
                                                icon={<FileDoneOutlined />}
                                                color="#4472C4"
                                                trend={{ up: true, text: `Tỷ lệ HT ${tongQuan.tyLe}%` }}
                                            />
                                        </Col>
                                        <Col span={6}>
                                            <SummaryCard
                                                title="Đã hoàn thành"
                                                value={currencyFormat.formatMoney(tongQuan.tongHT)}
                                                icon={<CheckCircleOutlined />}
                                                color="#22c55e"
                                            />
                                        </Col>
                                        <Col span={6}>
                                            <SummaryCard
                                                title="Đang thực hiện"
                                                value={currencyFormat.formatMoney(tongQuan.tongDTH)}
                                                icon={<ClockCircleOutlined />}
                                                color="#f59e0b"
                                            />
                                        </Col>
                                        <Col span={6}>
                                            <SummaryCard
                                                title="Không hoàn thành"
                                                value={tongQuan.tongTre}
                                                icon={<ExclamationCircleOutlined />}
                                                color="#ef4444"
                                            />
                                        </Col>
                                        <Col span={24}>
                                            <div style={{ height: 440 }}>
                                                <Chart
                                                    type="bar"
                                                    data={chartData}
                                                    options={options as any}
                                                    plugins={[dataLabelPlugin as any, phongBanLabelPlugin as any]}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            },
                            {
                                key: '2',
                                label: 'Đánh giá KPI',
                                children: <div className="card card-body" style={{ marginTop: 10, backgroundColor: '#fff', borderRadius: 8 }}>
                                    <Row gutter={8}>
                                        <Col span={24} style={{ marginTop: "20px" }}>
                                            <h4 style={{
                                                fontSize: 14,
                                                fontWeight: 700,
                                                color: '#203864'
                                            }}>
                                                XẾP LOẠI KPI THEO THÁNG
                                            </h4>
                                            <div style={{ height: 300 }}>
                                                <Bar
                                                    data={chartXepLoai}
                                                    options={chartOptions}
                                                    plugins={[totalPlugin]}
                                                />
                                            </div>
                                            {/*Danh sách kết quả xếp loại KPI theo Nhân viên ( danh sách nhân viên được order theo donvi.thutu, chucvu.thutu, nhanvien.thutu*/}
                                            <h4 style={{
                                                fontSize: 14,
                                                fontWeight: 700,
                                                color: '#203864',
                                                textTransform: 'uppercase',
                                                marginTop: 20,
                                                marginBottom: 9,
                                            }}>
                                                DANH SÁCH KẾT QUẢ XẾP LOẠI KPI THEO NHÂN VIÊN
                                            </h4>
                                            <Table
                                                size="small"
                                                columns={nhanVienColumns}
                                                dataSource={nhanVienRows}
                                                pagination={false}
                                                // tổng width các cột = 1570; cố định x để màn hình hẹp cuộn ngang
                                                // thay vì ép cột co lại làm chữ xuống dòng từng ký tự
                                                scroll={{ x: 1570, y: 400 }}
                                                bordered
                                                locale={{ emptyText: 'Không có dữ liệu' }}
                                            />
                                        </Col>
                                        {/* BẢNG LỖI VI PHẠM */}
                                        <Col span={24} style={{ marginTop: 20 }}>
                                            <Row align="middle" justify="space-between" style={{ marginBottom: "9px" }}>
                                                <Col span={18}>
                                                    <h4
                                                        style={{
                                                            fontSize: 14,
                                                            fontWeight: 700,
                                                            color: '#203864',
                                                            textTransform: 'uppercase',
                                                            marginBottom: 0,
                                                            marginRight: "10px",
                                                            display: 'inline-block',
                                                        }}
                                                    >
                                                        LỖI VI PHẠM
                                                    </h4>
                                                    <Space >
                                                        <Tag
                                                            color="#ef4444"
                                                            style={{
                                                                color: '#fff',
                                                                margin: 0,
                                                                padding: '2px 8px',
                                                                lineHeight: '1.5',
                                                                fontSize: '12px',
                                                                fontWeight: 600
                                                            }}
                                                        >
                                                            {tongSoLoi} LỖI
                                                        </Tag>

                                                        <Tag
                                                            color="#dc2626"
                                                            style={{
                                                                color: '#fff',
                                                                margin: 0,
                                                                padding: '2px 8px',
                                                                lineHeight: '1.5',
                                                                fontSize: '12px',
                                                                fontWeight: 600
                                                            }}
                                                        >
                                                            -{Math.abs(tongDiemTru)} ĐIỂM
                                                        </Tag>
                                                    </Space>
                                                </Col>
                                                <Col span={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <Select
                                                        value={filterThang}
                                                        onChange={setFilterThang}
                                                        options={monthOptions}
                                                        style={{ minWidth: 200 }}
                                                        size="middle"
                                                        allowClear
                                                        placeholder="Tất cả các tháng"
                                                    />
                                                </Col>
                                            </Row>
                                            <Table
                                                size="small"
                                                columns={violationColumns}
                                                dataSource={violations.map((v, i) => ({ ...v, key: i }))}
                                                pagination={false}
                                                scroll={{ y: 400 }}
                                                bordered
                                                locale={{ emptyText: 'Không có lỗi vi phạm trong khoảng thời gian này' }}
                                            />
                                        </Col>
                                    </Row>
                                </div>
                            },
                            {
                                key: '3',
                                label: 'Giao việc',
                                children: <div className="card card-body" style={{ marginTop: 10, backgroundColor: '#fff', borderRadius: 8 }}>
                                    <Row gutter={8}>
                                        <Col span={24}>
                                            <Row align="middle" justify="space-between" style={{ marginBottom: "9px" }}>
                                                <Col span={24} style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 10 }}>
                                                    <h4
                                                        style={{
                                                            fontSize: 14,
                                                            fontWeight: 700,
                                                            color: '#203864',
                                                            textTransform: 'uppercase',
                                                            marginBottom: 0,
                                                        }}
                                                    >
                                                        THEO DÕI CÔNG VIỆC DO LÃNH ĐẠO GIAO
                                                    </h4>
                                                    <Tag
                                                        color="#ef4444"
                                                        style={{
                                                            color: '#fff',
                                                            margin: 0,
                                                            padding: '2px 8px',
                                                            lineHeight: '1.5',
                                                            fontSize: '12px',
                                                            fontWeight: 600
                                                        }}
                                                    >
                                                        {new Set(theoDoiGiaoViecRows.map((r) => r.idNhom)).size} CÔNG VIỆC
                                                    </Tag>
                                                    <Button
                                                        className="hrm-btn hrm-btn-success"
                                                        icon={<DownloadOutlined rev="" />}
                                                        onClick={handleExportGiaoViec}
                                                        style={{ marginLeft: 'auto' }}
                                                    >Xuất excel
                                                    </Button>
                                                </Col>
                                            </Row>
                                            <Table
                                                size="small"
                                                columns={theoDoiGiaoViecColumns}
                                                dataSource={theoDoiGiaoViecRows}
                                                pagination={false}
                                                scroll={{ x: widthBangGiaoViec, y: 600 }}
                                                bordered
                                                // tô sáng dòng đang sửa / đang hỏi ẩn - xóa
                                                rowClassName={(record: any) => (record.idNhom === idNhomXoaGiaoViec
                                                    || record.id === giaoViecDangSua?.id) ? "selected-row row-key-" : ""}
                                                locale={{ emptyText: 'Không có công việc được giao' }}
                                            />
                                        </Col>
                                    </Row>
                                </div>
                            },
                        ]}
                    />

                </Col>
            </Row>
            <Modal
                title="Sửa công việc đã giao"
                open={!!giaoViecDangSua}
                onOk={() => formSuaGiaoViec.submit()}
                onCancel={() => setGiaoViecDangSua(null)}
                okText="Lưu"
                cancelText="Hủy"
                confirmLoading={dangLuuGiaoViec}
                maskClosable={false}
                destroyOnClose
                width={640}
            >
                <Form
                    form={formSuaGiaoViec}
                    layout="vertical"
                    preserve={false}
                    onFinish={handleSuaGiaoViec}
                    initialValues={{
                        tenCongViec: giaoViecDangSua?.tenCongViec,
                        thoiGianGiao: giaoViecDangSua?.thoiGianGiao ? dayjs(giaoViecDangSua.thoiGianGiao) : null,
                        thoiGianYeuCauHoanThanh: giaoViecDangSua?.thoiGianYeuCauHoanThanh ? dayjs(giaoViecDangSua.thoiGianYeuCauHoanThanh) : null,
                        choSuaThoiGianHT: !!giaoViecDangSua?.choSuaThoiGianHT,
                        baoCaoCapTren: !!giaoViecDangSua?.baoCaoCapTren,
                        ghiChu: giaoViecDangSua?.ghiChu,
                    }}
                >
                    <Form.Item
                        label="Nội dung công việc"
                        name="tenCongViec"
                        rules={[{ required: true, message: "Tên công việc bắt buộc nhập" }]}
                    >
                        <Input.TextArea rows={2} placeholder="Nhập công việc" />
                    </Form.Item>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="Thời gian giao"
                                name="thoiGianGiao"
                                style={{ marginBottom: 4 }}
                                rules={[{ required: true, message: "Thời gian giao bắt buộc nhập" }]}
                            >
                                <DatePicker
                                    style={{ width: "100%" }}
                                    changeOnBlur
                                    allowClear={false}
                                    format={dateFormat}
                                    onChange={(e: any) => {
                                        const hoanThanh = formSuaGiaoViec.getFieldValue("thoiGianYeuCauHoanThanh");
                                        if (e && hoanThanh && e.isAfter(hoanThanh)) {
                                            formSuaGiaoViec.setFieldValue("thoiGianYeuCauHoanThanh", e);
                                        }
                                    }}
                                />
                            </Form.Item>
                            <Form.Item name="baoCaoCapTren" valuePropName="checked">
                                <Checkbox title="Báo cáo cấp trên">Báo cáo cấp trên</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Thời gian yêu cầu hoàn thành"
                                name="thoiGianYeuCauHoanThanh"
                                style={{ marginBottom: 4 }}
                                rules={[
                                    { required: true, message: "Thời gian yêu cầu hoàn thành bắt buộc nhập" },
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            const giao = getFieldValue("thoiGianGiao");
                                            if (!value || !giao || !value.isBefore(giao, 'day')) return Promise.resolve();
                                            return Promise.reject(new Error("Thời gian yêu cầu hoàn thành không được trước thời gian giao"));
                                        },
                                    }),
                                ]}
                            >
                                <DatePicker
                                    style={{ width: "100%" }}
                                    changeOnBlur
                                    allowClear={false}
                                    placeholder="Chọn ngày"
                                    format={dateFormat}
                                />
                            </Form.Item>
                            <Form.Item name="choSuaThoiGianHT" valuePropName="checked">
                                <Checkbox title="Cho sửa thời gian yêu cầu hoàn thành">Cho sửa thời gian hoàn thành</Checkbox>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item label="Ghi chú" name="ghiChu" style={{ marginBottom: 0 }}>
                        <Input.TextArea rows={2} placeholder="Nhập ghi chú" />
                    </Form.Item>
                </Form>
            </Modal>
        </section>
    );
};

export default ThongKeKPI;